define('app/models/user',['app/setup',
    'app/factories/navigation_factory',
    'app/views/navigation_view'], function(takhfifan) {
  takhfifan.User = Backbone.Model.extend({

    validation: {
      'username': [{
          required: true,
          msg: i18n.t('email_missing')
        }, {
          pattern: 'email',
          msg: i18n.t('email_invalid')
      }],
      'password': {
        required: true,
        rangeLength: [6,50],
        pattern: /^\S{6,50}$/,
        msg: i18n.t('password_invalid')
      }
    },

    login: function() {
      var _this = this;
      takhfifan.eventHub.trigger('customer:loginStart', []);

      $.ajaxSetup({
        xhrFields: {
          withCredentials: true
        }
      });

      $.post(this.get('loginUrl'), {
          'form_key': this.get('formKey'),
          'login[username]': this.get('username'),
          'login[password]': this.get('password')
      }).done(function(data){
        if(data.quote_changed){
          window.location.replace('/checkout/cart');
          return;
        }
        takhfifan.eventHub.trigger('customer:loginEnd', []);
        if (!_.isNull(data.errors) && !_.isEmpty(data.errors)) {
          takhfifan.eventHub.trigger('customer:loginError', data.errors);
        } else {
          takhfifan.eventHub.trigger('session:updated', data);
        }
        webengage.user.login(data.customer.id); //9SBOkLVMWvPX is the unique user identifier being used here
        webengage.user.setAttribute({
          "we_last_name": data.customer.name,
          "we_email": data.customer.email,
          "we_phone": data.customer.mobile,
        });
        webengage.track("login", {
          "method": "email",
          "last_name": data.customer.name,
          "mobile_number": data.customer.mobile,
          "email": data.customer.email,
          "customer_id": data.customer.id,
        });
      }).fail(function(data){
        takhfifan.eventHub.trigger('customer:loginEnd', []);
        takhfifan.eventHub.trigger(
          'customer:loginError',
          [i18n.t('connection_error')]
        );
      });
    },

    defaults: {
      name: null,
      username: null,
      password: null
    }
  });

});

